<template>
  <div>
    <div
      class="overlay"
      @click="toggle"
      :class="{ visible: GET_SIDEBAR_OPEN }"
    ></div>
    <div class="appSidebar">
      <div class="appSidebarContext" :class="{ visible: GET_SIDEBAR_OPEN }">
        <div class="abbSideBarHeader">
          <div class="headerBtn">
            <span class="imgWrap close" @click="toggle"
              ><img src="../assets/images/x.svg"
            /></span>
            <div class="headerImgWrap">
              <div class="bell" v-if="IS_LOGIN" @click="goPush()">
                <span class="imgWrap">
                  <img src="../assets/images/alarm_black.svg" />
                </span>
                <div class="count" v-if="getPushCounted >= 1">
                  <span class=""></span>
                </div>
              </div>
              <router-link to="/controllSetting">
                <span class="imgWrap"
                  ><img src="../assets/images/setting.svg"
                /></span>
              </router-link>
            </div>
          </div>
          <template v-if="IS_LOGIN">
            <div class="sideProfile">
              <h2>{{ GET_USERNAME }}님</h2>
              <h2>반갑습니다!</h2>
              <div class="logoutBtn">
                <p class="idText">{{ GET_ID }}</p>
                <button @click="logOutAction()">로그아웃</button>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="sideProfile userEmpty">
              <h2>로그인</h2>
              <h2>해주세요.</h2>
              <div class="logoutBtn">
                <button @click="logIn()">로그인</button>
              </div>
            </div>
          </template>
        </div>
        <div class="sideContent" :class="{ visible: IS_LOGIN }">
          <div class="menu_wrap">
            <BaseAccordion :basic="basic">
              <template v-slot:title>
                <div class="mw_title">
                  <h2>진료예약</h2>
                  <div class="mw_arrow">
                    <img src="../assets/images/back_red.svg" />
                  </div>
                </div>
              </template>
              <template v-slot:content>
                <ul class="mw_content">
                  <div class="mw_item" v-if="IS_LOGIN">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/1.svg" />
                      </div>
                      <li @click="pressReservation()">
                        <span>진료예약</span>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item" v-else>
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/5.svg" />
                      </div>
                      <li>
                        <router-link to="/telReservation_step1">
                          <span>전화상담 신청</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/2.svg" />
                      </div>
                      <li>
                        <router-link to="/reservation/reservationConfirm">
                          <span>예약조회/변경</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/3.svg" />
                      </div>
                      <li>
                        <router-link to="/doctor/list">
                          <span>의료진소개</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/4.svg" />
                      </div>
                      <li>
                        <router-link to="/doctor/schedule">
                          <span>진료 시간표</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                </ul>
              </template>
            </BaseAccordion>
            <BaseAccordion :basic="basic">
              <template v-slot:title>
                <div class="mw_title">
                  <h2>검사결과 조회</h2>
                  <div class="mw_arrow">
                    <img src="../assets/images/back_red.svg" />
                  </div>
                </div>
              </template>
              <template v-slot:content>
                <ul class="mw_content">
                  <div class="mw_item">
                    <div class="mw_icon">
                      <img src="../assets/images/6.svg" />
                    </div>
                    <li>
                      <router-link to="/checkup/checkupList">
                        <span>검사결과 조회</span>
                      </router-link>
                    </li>
                  </div>
                </ul>
              </template>
            </BaseAccordion>
            <BaseAccordion :basic="basic">
              <template v-slot:title>
                <div class="mw_title">
                  <h2>제증명 발급</h2>
                  <div class="mw_arrow">
                    <img src="../assets/images/back_red.svg" />
                  </div>
                </div>
              </template>
              <template v-slot:content>
                <ul class="mw_content full">
                  <div class="mw_item">
                    <div class="mw_icon">
                      <img src="../assets/images/7.svg" />
                    </div>
                    <li>
                      <router-link to="/certificateList">
                        <span>증명서 발급 신청하기</span>
                      </router-link>
                    </li>
                  </div>
                  <div class="mw_item">
                    <div class="mw_icon">
                      <img src="../assets/images/8.svg" />
                    </div>
                    <li>
                      <router-link to="/certificateLookupList">
                        <span>증명서 발급 신청내역</span>
                      </router-link>
                    </li>
                  </div>
                </ul>
              </template>
            </BaseAccordion>
            <BaseAccordion :basic="basic">
              <template v-slot:title>
                <div class="mw_title">
                  <h2>수술관리</h2>
                  <div class="mw_arrow">
                    <img src="../assets/images/back_red.svg" />
                  </div>
                </div>
              </template>
              <template v-slot:content>
                <ul class="mw_content">
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/16.svg" />
                      </div>
                      <li>
                        <router-link to="/surgery/SurgeryReservationList">
                          <span>수술일정 조회</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/17.svg" />
                      </div>
                      <li>
                        <router-link to="/surgery/beforeCaution">
                          <span>수술전 주의사항</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/18.svg" />
                      </div>
                      <li>
                        <router-link to="/surgery/surgeryReviewList">
                          <span>수술후기</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/19.svg" />
                      </div>
                      <li>
                        <router-link to="/surgery/surgeryConsent">
                          <span>수술동의서</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/20.svg" />
                      </div>
                      <li>
                        <router-link to="/surgery/afterCaution">
                          <span>수술후 주의사항</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/21.svg" />
                      </div>
                      <li>
                        <router-link to="/surgery/afterCare">
                          <span>수술후 관리</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/22.svg" />
                      </div>
                      <li>
                        <router-link to="/surgery/kakaoUrl">
                          <span>수술후 카톡상담</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/23.svg" />
                      </div>
                      <li>
                        <router-link to="/surgery/voiceCare">
                          <span>음성치료</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/26.svg" />
                      </div>
                      <li>
                        <router-link to="/scar/scarList">
                          <span>흉터관리</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                </ul>
              </template>
            </BaseAccordion>
            <BaseAccordion :basic="basic">
              <template v-slot:title>
                <div class="mw_title">
                  <h2>병원안내</h2>
                  <div class="mw_arrow">
                    <img src="../assets/images/back_red.svg" />
                  </div>
                </div>
              </template>
              <template v-slot:content>
                <ul class="mw_content">
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/11.svg" />
                      </div>
                      <li>
                        <router-link to="/info/wayInfo">
                          <span>오시는 길</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/10.svg" />
                      </div>
                      <li>
                        <router-link to="/info/scheduleInfo">
                          <span>진료시간 안내</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/9.svg" />
                      </div>
                      <li>
                        <router-link to="/info/telInfo">
                          <span>전화번호 안내</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/12.svg" />
                      </div>
                      <li>
                        <router-link to="/info/facilityInfo">
                          <span>병원시설안내</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/13.svg" />
                      </div>
                      <li>
                        <router-link to="/info/hospitalInfo">
                          <span>입원생활안내</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/14.svg" />
                      </div>
                      <li>
                        <router-link to="/noticeList">
                          <span>공지사항</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/15.svg" />
                      </div>
                      <li>
                        <router-link to="/info/faq">
                          <span>FAQ</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                </ul>
              </template>
            </BaseAccordion>
            <BaseAccordion :basic="basic">
              <template v-slot:title>
                <div class="mw_title">
                  <h2>상담하기</h2>
                  <div class="mw_arrow">
                    <img src="../assets/images/back_red.svg" />
                  </div>
                </div>
              </template>
              <template v-slot:content>
                <ul class="mw_content">
                  <div class="mw_item" v-if="false">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/24.svg" />
                      </div>
                      <li>
                        <router-link to="/chatbot">
                          <span>챗봇상담</span>
                        </router-link>
                      </li>
                    </div>
                  </div>
                  <div class="mw_item">
                    <div class="rightFit">
                      <div class="mw_icon">
                        <img src="../assets/images/25.svg" />
                      </div>
                      <li>
                        <a
                          class="susteen"
                          href="https://cafe.naver.com/thanqseoul"
                          target="_blank"
                        >
                          <span>온라인상담(카페)</span>
                        </a>
                      </li>
                    </div>
                  </div>
                </ul>
              </template>
            </BaseAccordion>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopupSide" :popupSetSide="popupSetSide" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import BaseAccordion from "@/components/BaseAccordion";
import errorParser from "@/utils/error-parser";
import AddPopup from "@/components/AddPopupSide";
import EventBus from "../utils/bus";
export default {
  data() {
    return {
      basic: {
        isShow: true,
        isOpen: true,
      },
      os: "",
      version: "",
      mobileInfo: {
        info: false,
        check: false,
        os: "",
        version: "",
        option: "",
        url: "",
        update: false,
      },
      popupSetSide: {
        title: "",
        modalImg: "alert_cn.svg",
        content: "",
        confirmBtnText: "확인",
        count: "single",
        nextLink: "",
        closeType: "close",
      },
      firstVisit: false,
    };
  },
  created() {
    console.log("사이드바 created");
  },
  computed: {
    ...mapState(["checkPopupSide"]),
    ...mapGetters("push", ["getPushCounted"]),
    ...mapGetters([
      // 'GET_RESERVATION_MESSAGE',
      "GET_RESERVATION_CHECK",
      "GET_SCARINFO_LIST",
      "GET_SIDEBAR_OPEN",
      "IS_LOGIN",
      "GET_USERNAME",
      "GET_ID",
    ]),
  },
  methods: {
    ...mapMutations([
      "SET_SIDEBAR_OPEN",
      "SET_POPUP_SIDE",
      "SET_USERNAME",
      "SET_TOKEN",
      "SET_ID",
    ]),
    ...mapActions(["CHECK_RESERVATION", "FETCH_SCARINFO", "LOGOUT_USER"]),
    goPage() {
      window.open("https://cafe.naver.com/thanqseoul", "_blank");
    },
    toggle() {
      this.SET_SIDEBAR_OPEN(false);
    },
    async pressReservation() {
      try {
        await this.CHECK_RESERVATION().then(() => {
          if (this.GET_RESERVATION_CHECK.length !== undefined) {
            if (this.GET_RESERVATION_CHECK[0].flag === "first") {
              this.$router.push("/reservation/explain");
            } else if (this.GET_RESERVATION_CHECK[0].flag === "future") {
              this.$router.push("/reservation/reCare");
            } else {
              this.$router.push("/reservation/reCare");
            }
          } else {
            if (this.GET_RESERVATION_CHECK.flag !== undefined) {
              if (this.GET_RESERVATION_CHECK.flag === "first") {
                this.$router.push("/reservation/explain");
              } else if (this.GET_RESERVATION_CHECK.flag === "future") {
                this.$router.push("/reservation/reCare");
              } else {
                this.$router.push("/reservation/reCare");
              }
            } else {
              this.$router.push("/reservation/reCare");
            }
          }
        });
      } catch (error) {
        console.log("사이드바 예약 체크 에러에 진입함!");
        if (error.status !== 401) {
          this.SET_POPUP_SIDE(true);
          this.popupSetSide.content = errorParser.parse(error);
        } else {
          await this.$router.push("/login");
        }
      }
    },
    async pressScar() {
      try {
        await this.FETCH_SCARINFO().then(() => {
          console.log("이것은 살아있는가?", this.GET_SCARINFO_LIST);
          if (this.GET_SCARINFO_LIST === undefined) {
            this.$router.push("/scar/scarList");
          } else {
            this.$router.push("/scar/scarCheck");
          }
        });
      } catch (error) {
       console.log("error:", error);
        console.log("사이드바 예약 체크 에러에 진입함!");
        if (error.status !== 401) {
          this.SET_POPUP_SIDE(true);
          this.popupSetSide.content = errorParser.parse(error);
        } else {
          await this.$router.push("/login");
        }
      }
    },
    logIn() {
      this.$router.push("/logIn");
    },
    async logOutAction() {
      if (sessionStorage.getItem("userAgent") === "mobile") {
      }
      try {
        await this.LOGOUT_USER().then(() => {
          this.popupDriven();
          EventBus.$emit("logoutEvent", true);
        });
      } catch (error) {
        this.SET_SIDEBAR_OPEN(false);
        console.log("사이드바 -로그아웃에서 에러남");
        if (error.status !== 401) {
          this.SET_POPUP_SIDE(true);
          this.popupSet.content = errorParser.parse(error);
        } else {
          await this.$router.push("/login");
        }
      } finally {
      }
    },
    popupDriven() {
      // this.loginCheck = false
      this.SET_SIDEBAR_OPEN(false);
      this.SET_POPUP_SIDE(true);
      this.popupSetSide.content = "로그아웃 되었습니다.";
      this.popupSetSide.closeType = "action";
      this.popupSetSide.closeLink = "/";
      this.popupSetSide.count = "another";
      this.popupSetSide.nextLink = "/";
    },
    goPush() {
      this.$router.push("/pushList");
    },
  },
  components: {
    BaseAccordion,
    AddPopup,
  },
  beforeDestroy() {
    this.SET_SIDEBAR_OPEN(false);
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/sidebar";
</style>
